
import React, { useState, useEffect, useRef } from "react";
import HeroSection from "@/components/home/HeroSection";
import FeaturedAgentsSection from "@/components/home/FeaturedAgentsSection";
import BenefitsSection from "@/components/home/BenefitsSection";
import CategoriesSection from "@/components/home/CategoriesSection";
import AgentShowcaseSection from "@/components/home/AgentShowcaseSection";
import StatisticsSection from "@/components/home/StatisticsSection";
import HowItWorksSection from "@/components/home/HowItWorksSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import CtaSection from "@/components/home/CtaSection";

const Index = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [scrollY, setScrollY] = useState(0);
  const heroRef = useRef(null);

  // Handle scroll for parallax effects
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen">
      <HeroSection 
        scrollY={scrollY} 
        searchQuery={searchQuery} 
        setSearchQuery={setSearchQuery} 
        heroRef={heroRef} 
      />
      <FeaturedAgentsSection />
      <BenefitsSection />
      <CategoriesSection />
      <AgentShowcaseSection />
      <StatisticsSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <CtaSection />
    </div>
  );
};

export default Index;
